module.exports = "https://static.wmbcdn.com/uniweb/images/339a73a174c0a8908d9cfabb5506547a.svg";